import React, { useEffect, useRef, useState } from 'react';
import { Oval } from 'react-loader-spinner'
import toast, { Toaster } from 'react-hot-toast';
import { useFormik } from 'formik';
import * as yup from 'yup'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Container from '../Layouts/Container';
import moment from 'moment-timezone';
import { useDropzone } from 'react-dropzone';
import { addScreenAPI } from '../../API/OnboardingRequest';
import { sessionExpire } from '../../Scripts/Helper';
import { logoutAdmin } from '../../Action/authAction';
import { addDiscountBannerApi,poolPerksAllApi } from '../../API/DiscountsRequest';

const AddDiscount = () => {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const imageRef = useRef(null)
    const user = useSelector((state) => state.authReducer.authData)
    const authToken = useSelector((state) => state.authReducer.token)
    const [poolPerkData, setPoolPerkData] = useState([])


    // Get the user's time zone
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const [spinnerLoading, setSpinnerLoading] = useState(false)
    const [btnLoading, setBtnLoading] = useState(false)
    const [startDate, setStartDate] = useState()
    const [expiryDate, setExpiryDate] = useState()
    // const [startDate, setStartDate] = useState(moment.utc(moment()).tz(userTimeZone).format('YYYY-MM-DD'))
    // const [expiryDate, setExpiryDate] = useState(moment.utc(moment().add(1, 'day')).tz(userTimeZone).format('YYYY-MM-DD'))
    const [screenImage, setScreenImage] = useState("")

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop: (acceptedFiles) => {
            setScreenImage(acceptedFiles[0])
            addNewDiscountForm.setFieldValue("image", acceptedFiles[0])
        },
    });

    const addNewDiscountForm = useFormik({
        initialValues: {
            title: "",
            description: "",
            discount_id:"",
            image: "",
            start_date: "",
            end_date: "",
        },
        enableReinitialize: true,
        validationSchema: yup.object({
            title: yup.string().required('Title is required'),
            description: yup.string().required('Description is required'),
            discount_id: yup.string().required('Discount is required'),
            image: yup.string().required('Image is required'),
            start_date: yup.string().required('Start Date is required'),
            end_date: yup.string().required('Expiration Date is required'),
        }),
        onSubmit: async (values, { resetForm }) => {
            setBtnLoading(true)

            const formData = new FormData();
            formData.append("title", addNewDiscountForm.getFieldProps('title').value)
            formData.append("description", addNewDiscountForm.getFieldProps('description').value)
            formData.append("discount_id", addNewDiscountForm.getFieldProps('discount_id').value)
            formData.append("image", screenImage);
            formData.append("start_date", moment(startDate).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"));
            formData.append("end_date", moment(expiryDate).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"));

            const config = {
                headers: { Authorization: `Bearer ${authToken}` }
            }
            await addDiscountBannerApi(formData, config)
                .then((res) => {

                    navigate('/discount')
                    setTimeout(() => {
                        toast.success(res.data.message)
                    }, 100);

                }).catch((err) => {
                    console.log("🚀 ~ file: Profile.jsx:80 ~ err:", err)

                    if (err.code == "ERR_NETWORK") {
                        toast.error("Something went wront! please try again later")
                    }
                    else {
                        let res = sessionExpire(err)
                        toast.error(res.message)

                        if (res.status) {
                            dispatch(logoutAdmin())
                            navigate('/login')
                        }
                    }
                })

            setBtnLoading(false)
        }
    })

    useEffect(() => {
        !user && navigate('/login')
        fetchPerksList()
    }, []);

    let fetchPerksList = async () => {
        setSpinnerLoading(true)

        const config = {
            headers: {
                Authorization: `Bearer ${authToken}`,
                time_zone: userTimeZone,
            }
        }

        await poolPerksAllApi(config)
            .then((response) => {

                console.log(response,'response')
                setPoolPerkData(response ? response.data ? response.data.data : [] : [])

            }).catch((err) => {
                console.log("🚀 ~ .then ~ err:", err)

                if (err.code == "ERR_NETWORK") {  
                    toast.error("Something went wront! please try again later")
                }
                else {
                    let res = sessionExpire(err)
                    console.log("🚀 ~ .then ~ err:", err)
                    toast.error(res.message)

                    if (res.status) {
                        dispatch(logoutAdmin())
                        navigate('/login')
                    }
                }
            })
        setSpinnerLoading(false)
    }

    return (
        <>
            {user &&
                <Container>
                    <Toaster position="top-right" reverseOrder={false} />
                    <div className="nk-content mt-5">
                        <div className="container-fluid mt-4">
                            <div className="nk-content-inner">
                                <div className="nk-content-body">
                                    <div className="nk-block-head nk-block-head-sm">
                                        <div className="nk-block-between">
                                            <div className="nk-block-head-content">
                                                <h4 className="nk-block-title page-title">The Pool Store /
                                                    <span> Add Discount Banner</span>
                                                </h4>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="row g-gs mt-3">
                                        <div className="col-md-12">

                                            <div className="row g-gs">
                                                <form className="row" onSubmit={addNewDiscountForm.handleSubmit}>


                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <div className="form-control-wrap whatNewInput">
                                                                <label className="form-label">Title</label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control form-control-lg"
                                                                    placeholder="Title"
                                                                    {...addNewDiscountForm.getFieldProps("title")}
                                                                />
                                                                {addNewDiscountForm.touched.title && addNewDiscountForm.errors.title
                                                                    ? <div className="invalid-feedback" style={{ display: "block" }}>
                                                                        {addNewDiscountForm.errors.title}
                                                                    </div>
                                                                    : ''
                                                                }
                                                            </div>
                                                        </div>
                                                        <div className="form-group">
                                                            <div className="form-control-wrap whatNewInput">
                                                                <label className="form-label">Description</label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control form-control-lg"
                                                                    placeholder="Sub title"
                                                                    {...addNewDiscountForm.getFieldProps("description")}
                                                                />
                                                                {addNewDiscountForm.touched.description && addNewDiscountForm.errors.description
                                                                    ? <div className="invalid-feedback" style={{ display: "block" }}>
                                                                        {addNewDiscountForm.errors.description}
                                                                    </div>
                                                                    : ''
                                                                }
                                                            </div>
                                                        </div>
                                                        <div className="form-group">
                                                            <div className="form-control-wrap whatNewInput">
                                                                <label className="form-label">Discount</label>

                                                                <select className="form-control form-control-lg" {...addNewDiscountForm.getFieldProps("discount_id")}>
                                                                    <option>Select Discount</option>
                                                                    {poolPerkData.map((perk, index) => (
                                                                        <option key={index} value={perk.id}>{perk.title}</option>
                                                                    ))}
                                                                    </select>

                                                             
                                                                {addNewDiscountForm.touched.discount_id && addNewDiscountForm.errors.discount_id
                                                                    ? <div className="invalid-feedback" style={{ display: "block" }}>
                                                                        {addNewDiscountForm.errors.discount_id}
                                                                    </div>
                                                                    : ''
                                                                }
                                                            </div>
                                                        </div>
                                                        <div className="form-group">
                                                            <div className="form-control-wrap whatNewInput">
                                                                <label className="form-label">Start Date</label>
                                                                <input
                                                                    type="date"
                                                                    className="form-control form-control-lg"
                                                                    min={moment.utc(moment()).tz(userTimeZone).format('YYYY-MM-DD')}
                                                                    value={startDate}
                                                                    onChange={e => {
                                                                        setStartDate(moment.utc(moment(e.target.value)).tz(userTimeZone).format('YYYY-MM-DD'))
                                                                        addNewDiscountForm.setFieldValue("start_date", e.target.value)
                                                                        setExpiryDate("")
                                                                    }}
                                                                />
                                                                {addNewDiscountForm.touched.start_date && addNewDiscountForm.errors.start_date
                                                                    ? <div className="invalid-feedback" style={{ display: "block" }}>
                                                                        {addNewDiscountForm.errors.start_date}
                                                                    </div>
                                                                    : ''
                                                                }
                                                            </div>
                                                        </div>
                                                        <div className="form-group">
                                                            <div className="form-control-wrap whatNewInput">
                                                                <label className="form-label">Expiration Date</label>
                                                                <input
                                                                    type="date"
                                                                    min={moment.utc(moment().add(1, 'day')).tz(userTimeZone).format('YYYY-MM-DD')}
                                                                    value={expiryDate}
                                                                    className="form-control form-control-lg"
                                                                    onChange={e => {
                                                                        setExpiryDate(moment.utc(moment(e.target.value)).tz(userTimeZone).format('YYYY-MM-DD'))
                                                                        addNewDiscountForm.setFieldValue("end_date", e.target.value)
                                                                    }}
                                                                />
                                                                {addNewDiscountForm.touched.end_date && addNewDiscountForm.errors.end_date
                                                                    ? <div className="invalid-feedback" style={{ display: "block" }}>
                                                                        {addNewDiscountForm.errors.end_date}
                                                                    </div>
                                                                    : ''
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div className="col-md-6">


                                                        <div className="form-group">
                                                            <label className="form-label">Discount Banner</label>
                                                            {screenImage
                                                                ?
                                                                <div>
                                                                    <img src={URL.createObjectURL(screenImage)} alt="Screen Image" style={{ width: "250px" }} />
                                                                    <em
                                                                        role="button"
                                                                        className="far fa-solid fa-2x fa-rectangle-xmark"
                                                                        style={{ position: "absolute" }}
                                                                        onClick={e => {
                                                                            setScreenImage("")
                                                                            addNewDiscountForm.setFieldValue("image", "")
                                                                        }}
                                                                    />
                                                                </div>
                                                                : <div className=""  {...getRootProps()}>
                                                                    <input {...getInputProps()} />
                                                                    {isDragActive
                                                                        ?
                                                                        <div className='d-flex justify-content-center align-items-center border border-3 border-dashed rounded-3' style={{ width: "350px", height: "350px", backgroundColor: "whitesmoke" }}>
                                                                            <h6>Drop the image here...</h6>
                                                                        </div>
                                                                        : <div className='d-flex justify-content-center align-items-center border border-3 border-dashed rounded-3 flex-column p-2'>
                                                                            <img className="imgUploadIcon" src="images/Image.png" alt="user-avatar" />
                                                                            <div className="btn uploadTxt">
                                                                                <em className="icon ni ni-upload" /> Upload Image
                                                                            </div>
                                                                            <div className="dz-message" data-dz-message="">
                                                                                <span className="dz-message-or">Select or drag & drop onboarding screen image here.</span><br />
                                                                                <span className="dz-message-text">File Format jpeg, png Accepted Size 1000x1000</span>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    {addNewDiscountForm.touched.image && addNewDiscountForm.errors.image
                                                                        ? <div className="invalid-feedback" style={{ display: "block" }}>
                                                                            {addNewDiscountForm.errors.image}
                                                                        </div>
                                                                        : ''
                                                                    }
                                                                </div>
                                                            }
                                                        </div>
                                                        {btnLoading
                                                            ? <div className='flex justify-center items-center'>
                                                                <Oval
                                                                    height="30"
                                                                    width="30"
                                                                    color='var(--ps-main)'
                                                                    secondaryColor="var(--ps-main)"
                                                                    ariaLabel='oval-loading'
                                                                    strokeWidth={4}
                                                                    strokeWidthSecondary={4}
                                                                    visible={true}
                                                                />
                                                            </div>
                                                            : <button type="submit px-5" className="btn btn-primary d-inline w-100">Submit</button>
                                                        }
                                                    </div>

                                                </form>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </Container>
            }
        </>
    );
}

export default AddDiscount;
